import { DynamicInputFormType, InputTypes } from "../../../../../Components";

export const VergenceFacilityConfig: {
  type: string;
  title: string;
  fields: DynamicInputFormType[];
} = {
  type: "Vergence Facility",
  title: "Vergence Facility",
  fields: [
    {
      dataType: InputTypes.Date,
      accessor: "Date",
      Header: "Date",
    },
    {
      dataType: InputTypes.Number,
      accessor: "Cycles/Minute",
      Header: "Cycles/Minute",
    },
  ],
};
